import { jsx as t, jsxs as x } from "react/jsx-runtime";
import g from "sanitize-html";
import { IconNames as i } from "@blueprintjs/icons";
import { FormFieldWrapper as k } from "@strata/react-form-field-wrapper";
import { Icon as a } from "@strata/react-status-icons";
import { createButton as v, EditorProvider as R, Editor as w, Toolbar as E, Separator as I } from "react-simple-wysiwyg";
import "./main.scss";
import { getValidationMessage as S } from "@strata/helper-functions";
import { Field as D } from "formik";
const U = {
  allowedTags: [
    "b",
    // bold
    "i",
    // italic
    "u",
    // underline
    "strike",
    // strikethrough
    "a",
    // anchor, for hyperlinks
    "br",
    // line break
    "div",
    // division/section
    "ol",
    // ordered list
    "ul",
    // unordered list
    "li"
    // list item
  ],
  allowedAttributes: {
    a: ["href"]
    // hyperlink reference
  }
}, A = (e) => g(e, U), Y = ({ value: e, ...r }) => (
  // eslint-disable-next-line react/no-danger, xss/no-mixed-html, react/jsx-props-no-spreading
  /* @__PURE__ */ t("div", { dangerouslySetInnerHTML: { __html: A(e) }, ...r })
), s = (e, r, l) => {
  const c = v(e, r, l);
  return ({ disabled: m = !1 }) => m ? r : /* @__PURE__ */ t(c, {});
}, F = s(
  "Bold",
  /* @__PURE__ */ t(a, { className: "rsw-btn__icon", icon: i.BOLD }),
  "bold"
), H = s(
  "Bullet list",
  /* @__PURE__ */ t(a, { className: "rsw-btn__icon", icon: i.PROPERTIES }),
  "insertUnorderedList"
), O = s(
  "Italic",
  /* @__PURE__ */ t(a, { className: "rsw-btn__icon", icon: i.ITALIC }),
  "italic"
), M = s(
  "Strike through",
  /* @__PURE__ */ t(a, { className: "rsw-btn__icon", icon: i.STRIKETHROUGH }),
  "strikeThrough"
), W = s(
  "Numbered list",
  /* @__PURE__ */ t(a, { className: "rsw-btn__icon", icon: i.NUMBERED_LIST }),
  "insertOrderedList"
), z = s(
  "Underline",
  /* @__PURE__ */ t(a, { className: "rsw-btn__icon", icon: i.UNDERLINE }),
  "underline"
), C = s(
  "Link",
  /* @__PURE__ */ t(a, { className: "rsw-btn__icon", icon: i.LINK }),
  ({ $selection: e }) => {
    (e == null ? void 0 : e.nodeName) === "A" ? document.execCommand("unlink") : document.execCommand("createLink", !1, prompt("URL", "") ?? void 0);
  }
), P = ({
  id: e,
  name: r,
  helperText: l,
  inline: c = !1,
  label: d = "",
  fill: m,
  required: h = !1,
  placeholderText: p = "",
  requiredValidationMessage: B,
  verticalSpacingSmall: _ = !1,
  disabled: n = !1,
  onChange: u,
  onBlur: N,
  value: f = "",
  autoFocus: L = !1,
  tabIndex: T
}) => /* @__PURE__ */ t(
  k,
  {
    label: d,
    labelFor: e,
    disabled: n,
    helperText: l,
    inline: c,
    fill: m,
    required: h,
    requiredValidationMessage: B,
    verticalSpacingSmall: _,
    inputContent: /* @__PURE__ */ t("div", { className: "sds_rich-text-area", children: /* @__PURE__ */ t(R, { children: /* @__PURE__ */ t(
      w,
      {
        autoFocus: L,
        disabled: n,
        id: e,
        name: r,
        placeholder: p,
        value: f,
        onChange: (o) => {
          o.target.value === "<br>" && (o.target.value = ""), u == null || u(o);
        },
        onBlur: N,
        tabIndex: T,
        role: "textbox",
        children: /* @__PURE__ */ x(E, { children: [
          /* @__PURE__ */ t(F, { disabled: n }),
          /* @__PURE__ */ t(O, { disabled: n }),
          /* @__PURE__ */ t(z, { disabled: n }),
          /* @__PURE__ */ t(M, { disabled: n }),
          /* @__PURE__ */ t(I, {}),
          /* @__PURE__ */ t(W, { disabled: n }),
          /* @__PURE__ */ t(H, { disabled: n }),
          /* @__PURE__ */ t(I, {}),
          /* @__PURE__ */ t(C, { disabled: n })
        ] })
      }
    ) }) })
  }
), Z = ({
  id: e,
  helperText: r,
  inline: l,
  label: c,
  fill: d,
  required: m,
  placeholderText: h,
  requiredValidationMessage: p,
  verticalSpacingSmall: B,
  disabled: _,
  onChange: n,
  onBlur: u,
  value: N,
  autoFocus: f,
  tabIndex: L,
  validate: T = void 0
}) => /* @__PURE__ */ t(D, { name: e, validate: T, children: ({ field: o, form: b }) => /* @__PURE__ */ t(
  P,
  {
    id: o.name,
    name: o.name,
    disabled: _,
    label: c,
    helperText: r,
    inline: l,
    required: m,
    requiredValidationMessage: p ?? S(o.name, b),
    verticalSpacingSmall: B,
    fill: d,
    placeholderText: h,
    onChange: n ?? b.handleChange,
    onBlur: u ?? b.handleBlur,
    value: N ?? o.value,
    autoFocus: f,
    tabIndex: L
  }
) });
export {
  Y as DisplayRichText,
  P as RichTextArea,
  Z as RichTextAreaFormik,
  A as sanitizeHtml
};
//# sourceMappingURL=index.js.map
